import type { FormatterProps } from '../types';
import React from 'react';

function ValueFormatterComponent<R, SR>(props: FormatterProps<R, SR>) {
  try {
    return <>{props.row[props.column.key as keyof R]}</>;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return null;
  }
}

const ValueFormatter = React.memo(
  ValueFormatterComponent,
  (prevProps, nextProps) =>
    prevProps.row === nextProps.row && prevProps.column === nextProps.column,
);

export { ValueFormatter };
